import $ from 'jquery';
import objectFitImages from 'object-fit-images';
import Svg4EverybodyClass from 'svg4everybody';
import FiguresPopupClass from './modules/figures-popup';
import ContentsListClass from './modules/contents-list';
import ChaptersClass from './modules/chapters';
import PrevNextBtnsClass from './modules/prev-next-btns';
import NotesClass from './modules/notes';
import SocialSharing from './modules/social-sharing';
import ContentsDropdown from './modules/contents-dropdown';
import HeaderShare from './modules/header-share';
import HighlightToTweet from './modules/highlight-to-tweet';
import Table from './modules/table';
import TargetBlankLinks from './modules/target-blank-links';
import Tooltip from './modules/tooltip';


(function ($) {
    'use strict';

    const $chapters = $('.js-chapter');

    const $contentsList = new ContentsListClass($('.js-contents-list'), $chapters, $('.js-chapter-nav__btn'));
    new ChaptersClass($chapters, $contentsList);
    new ContentsDropdown();
    new FiguresPopupClass($('.js-figure-popup'));
    new HeaderShare();
    new PrevNextBtnsClass($('.js-chapter-nav__btn'), $chapters);
    new HighlightToTweet($('.js-highlight-to-tweet'));
    new NotesClass();
    new SocialSharing('.js-social-share');
    new Svg4EverybodyClass();
    new Table();
    new TargetBlankLinks();
    new Tooltip(767);

    /**
     * Object fit polyfill
     */
    objectFitImages();
}($));
